import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { ADAPTER_SVC_PARTNER_PORTAL_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IPostResamaniaChannel } from '~/Models/DTO/IntegrationChannels.model';

interface IPostChannel {
  location: string;
}

interface IPostChannelResponse {
  id: string;
}

export const useRequestPostResamaniaChannel = ({ location }: IPostChannel) =>
  useMutation<IPostChannelResponse, IErrorResponse, IPostResamaniaChannel>(
    [REQUEST_ACTIONS.POST_RESAMANIA_CHANNEL, location],
    async (params: IPostResamaniaChannel) =>
      requestReactQuery<IPostChannelResponse>({
        url: routeReplacer(ADAPTER_SVC_PARTNER_PORTAL_URLS.POST_INTEGRATION_CHANNEL, {
          location,
        }),
        config: { method: 'POST' },
        data: params,
      }),
  );
